import { onBeforeUnmount, Ref, watch } from 'vue';
import { B2CProductDetailTileModel } from '@/types/B2CcontentServerContract';
import { B2BProductDetailTileModel } from '@/types/B2BcontentServerContract';
import { StoreProductDetailTileModel } from '@/types/StoreContextContentServerContract';
import useProductDetailData from '@/shared/product/details/useProductDetailData';
import useSpecialDeliveryRequest from '@/shared/product/details/useSpecialDeliveryRequest';
import useProductDetailConfigurator from '@/shared/product/details/useProductDetailConfigurator';
import useProductDetailUpsell from '@/shared/product/upsell/useProductDetailUpsell';
import gtm from '@/shared/tracking/gtm.service';
import { useModuleConfigurator } from './ui/module-configurator/useModuleConfigurator';
import { useRouteQuery } from '@/core/browser/route-query.composable';
import { QueryKeys } from '@/shared/config/route-query.config';
import useCO2EmissionsLogo from '@/shared/product/details/emissions/useCO2EmissionsLogo';

export default function useProductDetailTileModel() {
    let cancelHandleProductTileModelChange;
    const { setProductData, clearProductData } = useProductDetailData();
    const { setLink: setSpecialDeliveryLink } = useSpecialDeliveryRequest();
    const { setLink: setConfiguratorLink } = useProductDetailConfigurator();
    const { setConfigurator, clearConfigurator } = useModuleConfigurator();
    const configurationId = useRouteQuery(QueryKeys.PDPConfigurationId);
    const { setLogo: setCO2EmissionsLogo } = useCO2EmissionsLogo();

    const { setIsUpsellEnabled } = useProductDetailUpsell();
    const handleProductTileModelChange = (model: Ref<B2CProductDetailTileModel | B2BProductDetailTileModel | StoreProductDetailTileModel>) => {
        cancelHandleProductTileModelChange = watch(model, (value) => {
            setProductData(value.productDetail);
            setSpecialDeliveryLink((value as B2CProductDetailTileModel).specialDeliveryRequestLinkModel);
            setConfiguratorLink((value as StoreProductDetailTileModel).designYourSelfLink);
            setIsUpsellEnabled((value as B2CProductDetailTileModel).powerStep?.isEnabled);
            if (value.productDetail.isConfigurable && value.moduleConfigurator.isEnabled) {
                setConfigurator((value as B2CProductDetailTileModel).moduleConfigurator, configurationId.value, value.productDetail.name);
            } else {
                clearConfigurator();
            }
            setCO2EmissionsLogo(value.co2EmissionsLogo);

            gtm.viewItem(value.productDetail);
            gtm.ecommerce(value.productDetail);
        }, { immediate: true });
    };

    onBeforeUnmount(() => {
        clearProductData();
        if (cancelHandleProductTileModelChange) {
            cancelHandleProductTileModelChange();
        }
    });

    return {
        handleProductTileModelChange,
    };
}
